import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container maxWidth-sm"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px"} }, null, -1)
const _hoisted_3 = { class: "title-container" }
const _hoisted_4 = { class: "title-text" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", { class: "hr-magazine hr-magazine-left hr-magazine-thick hr-magazine-short" }, null, -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1)

import { computed, ref } from "vue";
import { CmsReport } from "../../services/cms/types/cms-report";
import {
  CmsDevelopPage,
  CmsDocument,
  CmsResource,
  CmsResourceData,
} from "../../services/cms/cms-type-definitions";
import cms from "../../services/cms/cms";
import CmsBody from "../../components/cms/cms-body.vue";
import CmsImg from "../../components/cms/cms-img.vue";
import SwipeNavigationInfo from "../../components/swipe-navigation-info";


export default /*#__PURE__*/_defineComponent({
  __name: 'cms-text-page',
  props: {
    doc: {},
    context: {}
  },
  setup(__props: any) {

const props = __props;

const doc = computed(() => props.doc as CmsResource | CmsReport | CmsDevelopPage);
const developDoc = computed(() => props.doc as CmsDevelopPage);

const lastType = ref<string | null>(null);
const lastUid = ref<string | null>(null);
const loadedDoc = ref<CmsDocument | null>(null);

const headerImageSrc = computed(() => {
  if (props.doc?.type === "cms-report") return "";

  const { title_image, title_image_animation } = props.doc?.data as CmsResourceData;
  return title_image_animation?.url ?? title_image;
});

const canGoBack = computed(() => !!document.referrer);
const title = computed(() => cms.asText((props.doc?.data as CmsResourceData)?.title));
const titleHtml = computed(() => cms.asHtml((props.doc?.data as CmsResourceData)?.title));
const subtitle = computed(() => cms.asText((props.doc?.data as CmsResourceData)?.subtitle));
const pageTheme = computed(() => (props.doc?.data as CmsResourceData)?.page_visual_theme);
const titleLayout = computed(() => (props.doc?.data as CmsResourceData)?.title_layout || "");

const headerImage = ref();

function triggerAnimation(): void {
  (headerImage.value as any).animate();
}

function back(): void {
  SwipeNavigationInfo.temporarilyDisable();
  window.history.back();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([titleLayout.value, "cms-text-page"])
  }, [
    (doc.value.type !== 'cms-report')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          (canGoBack.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-primary-back button-with-icon-and-text hidden-print back-button",
                onClick: back
              }, " Back "))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", { innerHTML: titleHtml.value }, null, 8, _hoisted_5),
              _hoisted_6,
              (subtitle.value)
                ? (_openBlock(), _createElementBlock("h2", _hoisted_7, _toDisplayString(subtitle.value), 1))
                : _createCommentVNode("", true),
              _hoisted_8
            ]),
            _createElementVNode("div", {
              onMouseenter: triggerAnimation,
              onFocusin: triggerAnimation
            }, [
              (headerImageSrc.value)
                ? (_openBlock(), _createBlock(CmsImg, {
                    key: 0,
                    ref_key: "headerImage",
                    ref: headerImage,
                    src: headerImageSrc.value,
                    class: "title-image"
                  }, null, 8, ["src"]))
                : _createCommentVNode("", true)
            ], 32)
          ]),
          _hoisted_9
        ]))
      : _createCommentVNode("", true),
    _createVNode(CmsBody, {
      cmsPage: developDoc.value,
      context: _ctx.context
    }, null, 8, ["cmsPage", "context"])
  ], 2))
}
}

})